module.exports = __webpack_public_path__ + "media/images/median-house-costs-54c7f82649a746d705637b58eeb86036.png";